// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/checkbox/Controlled.story.tsx with go/sail-next-tailor-docs-publisher 

import * as React from 'react';
import { Checkbox } from '@sail/ui';
export const Controlled = () => {
  const [checked, setChecked] = React.useState(false);
  return <Checkbox onChange={() => {
    setChecked(!checked);
  }} checked={checked} label="This Checkbox is controlled." />;
};